/* jshint esversion: 6 */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    //环境配置
    systemConfig:{
      systemName:"诉讼服务自助一体机",//系统名称
      screenWidth:"1920",//屏幕宽度
      screenHeight:"1080",//屏幕高度
      timeNumber: 120, //定时退出时常
    },
    //基于bootstrap的弹窗
    globalModal:{
      isOpen:false, //是否打开
      modelTitle : "提示",//弹窗标题
      modelContent : "", //弹窗主体
      okTitle : "确定",//确定按钮
      cancelTitle : "取消",//取消按钮
      okOnly : false
    }
  },
  actions: {},
  mutations: {
    SET_TIMER: (state,val) => {
      state.resetTime = val;
    },
    SET_MODAL : (state,val) => {
      for(let i in val){
        state.globalModal[i] = val[i]
      }
    }
  },
  getters: {
    systemConfig: state => state.systemConfig,
    globalModal :state => state.globalModal
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js